import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { DownOutlined } from "@ant-design/icons";
import { Dropdown, Space } from "antd";
import {
  RepeatSendIcon,
  SaveIcon,
  SaveTemplateIcon,
  SendIcon,
  SendLaterIcon,
} from "assets/icons";
import { SEND_MESSAGE } from "constants";
import styled from "styled-components";

import {
  buttonColor,
  buttonColorHover,
  buttonSize,
  minimunSize,
  styledObject,
} from "./styled";

import styles from "./styles.module.scss";
const { Button } = Dropdown;

const sendMessageItems = [
  {
    key: SEND_MESSAGE.SEND_NOW,
    icon: <SendIcon />,
  },
  {
    key: SEND_MESSAGE.SEND_LATER,
    icon: <SendLaterIcon />,
  },
  {
    key: SEND_MESSAGE.SAVE_DRAFT,
    icon: <SaveIcon />,
  },
  {
    key: SEND_MESSAGE.SAVE_TEMPLATE,
    icon: <SaveTemplateIcon />,
  },
  {
    key: SEND_MESSAGE.REPEAT_SEND,
    icon: <RepeatSendIcon />,
  },
];

const ButtonDropdown = _props => {
  const {
    items = sendMessageItems,
    activeItem,
    size = "medium",
    color = "blue",
    varient = "contained",
    disabled,
    onButtonClick = () => {},
    onMenuClick = () => {},
  } = _props;
  const { t } = useTranslation();
  const isContainedButton = varient === "contained";

  const selectedItem = useMemo(() => {
    if (!activeItem) {
      return items[0];
    }
    return items.find(item => item.key === activeItem);
  }, [activeItem, items]);

  const handleButtonClick = () => {
    onButtonClick && onButtonClick();
  };
  const handleMenuClick = e => {
    onMenuClick && onMenuClick(e);
  };

  const menuProps = {
    items: items.map(item => {
      return {
        ...item,
        label: t(`label.${item.key}`),
      };
    }),
    className: styles.MenuDropDown,
    onClick: handleMenuClick,
  };

  const DropdownButtonStyled = styled(Button)(props => {
    return {
      ...styledObject(props),
      backgroundColor: "transparent!important",
      border: "none",
      "&:hover": {
        backgroundColor: "transparent!important",
      },
      "& .ant-btn-compact-first-item": {
        ...styledObject(props),
        minWidth: "unset",
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        borderRightColor: "#fff",
        "&:hover": {
          backgroundColor: "#fff",
        },
      },
      "& .ant-btn-compact-first-item[disabled]": {
        color: disabled ? "#FFFFFF!important" : "",
      },
      "& .ant-btn-compact-last-item": {
        ...styledObject(props),
        minWidth: "unset",
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        borderLeftColor: "#fff",
        "&:hover": {
          backgroundColor: "#fff",
        },
      },
    };
  });

  return (
    <Space wrap>
      <DropdownButtonStyled
        overlayClassName="buttonDropdown"
        menu={menuProps}
        placement="bottomLeft"
        icon={<DownOutlined />}
        disabled={disabled}
        onClick={handleButtonClick}
        $height={buttonSize[size]}
        $width={minimunSize[size]}
        $backgroundColor={
          isContainedButton ? buttonColor[color] : buttonColor.white
        }
        $color={isContainedButton ? buttonColor.white : buttonColor[color]}
        $hoverBackground={
          isContainedButton ? buttonColorHover[color] : buttonColor.white
        }
        $hoverColor={
          isContainedButton ? buttonColor.white : buttonColorHover[color]
        }
        $isContainedButton={isContainedButton}
      >
        {t(`label.${selectedItem?.key}`)}
      </DropdownButtonStyled>
    </Space>
  );
};

export default ButtonDropdown;
